import React, { useContext, useEffect, useState } from "react";
import{ zeroPad } from 'react-countdown';
import { useTranslation } from "react-i18next";
import { PinkNotification } from "../..";
import { BoardContext, SocketContext, TableContext, TeamContext } from "../../../../context";
import { Phase } from "../../../../util/enums";

const CountdownTimer = () => {
    const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { instructionTutorial, isWinnersPodiumShown, setIsWinnersPodiumShown } = useContext(BoardContext);
    const { setAreAnimatedHandsShown } = useContext(TableContext);
    const [remainingTime, setRemainingTime] = useState<any>(0);
    const startingTimeForCounterInMilliseconds = 180000;

    useEffect(() => {
        if (game?.phase === Phase.SLOT_MACHINE) {
            socket?.on("choosingStrengthCardsTime", time => {
                if( time > startingTimeForCounterInMilliseconds && remainingTime !== startingTimeForCounterInMilliseconds)
                    setRemainingTime(startingTimeForCounterInMilliseconds);

                if (time < startingTimeForCounterInMilliseconds)
                    setRemainingTime(time);
            });

            return () => {
                socket?.off("choosingStrengthCardsTime")
            }
        }
    });

    useEffect(() => {
        if (game?.phase !== Phase.SLOT_MACHINE) {
            socket?.on("time", time => {
                
                if (time > 10000)
                    setRemainingTime(time-10000);
                
                if (time <= 10000)
                    setRemainingTime(0);

                if (time < 10000){
                    setAreAnimatedHandsShown(false);
                    setIsWinnersPodiumShown(true);
                }

                if (isWinnersPodiumShown && time > 10000) {
                    setAreAnimatedHandsShown(true);
                    setIsWinnersPodiumShown(false);
                }
            });

            return () => {
                socket?.off("time");
            }
        }
    });

    const renderTime = () => {
        const remainingTimeInSeconds = remainingTime / 1000;
        const hours = Math.floor(remainingTimeInSeconds / (60 * 60));

        const divisorForMinutes = remainingTimeInSeconds % (60 * 60);
        const minutes = Math.floor(divisorForMinutes / 60);

        const divisorForSeconds = divisorForMinutes % 60;
        const seconds = Math.ceil(divisorForSeconds);

        if (hours >= 1) {
            return <span> {hours}:{zeroPad(minutes)}:{zeroPad(seconds)} </span>;
        }

        return <span> {minutes}:{zeroPad(seconds)}</span>;

    };

    return (
        <div className={` number_or_dilemmas_and_counterdown_box countdown_timer_wrapper_width center_horizontally_and_vertically  ${ instructionTutorial === "rightSideOfTheScreen" && "white_box_shadow"} `}>
            <div style={{position: "absolute", left: "0px", height: "100%"}}>
                <div className="new_icon_wrappper">
                    <div className="clock_icon"> </div>
                </div>
                {instructionTutorial === "rightSideOfTheScreen" && <PinkNotification notificationWidthVW={18} notificationRenderingSide="bottom" text={t("tipTimerHowMuchTimeIsLeftForTheGameText")} moveFromTop={0} progressNumber={9} areDotsPositionedToBottom={true} /> }
            </div>
            <div className="new_time_countdown_wrappper center_horizontally_and_vertically">
                {renderTime()}
            </div>
        </div>
    );
}

export default CountdownTimer;